/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ms-Tooltip{max-width:364px;background:"},{"theme":"white","defaultValue":"#ffffff"},{"rawString":";padding:8px}.ms-Tooltip.has-mediumDelay{-webkit-animation-delay:.3s;animation-delay:.3s}.ms-Tooltip-subText{margin:0;font-size:12px;color:"},{"theme":"neutralPrimary","defaultValue":"#333333"},{"rawString":"}.ms-TooltipHost{display:inline}"}]);
/* tslint:enable */